import React from 'react';
import {
    TextField,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {useTranslation} from "react-i18next";

const ConnectorFormStatusDelivered = ({ connectorDeliveredStatuses, deliveredStatus, setDeliveredStatus, ...rest }) => {
    const {t} = useTranslation('connector');
    return (
        <Autocomplete
            options={connectorDeliveredStatuses}
            value={ deliveredStatus ? connectorDeliveredStatuses.find(ces => ces.id == deliveredStatus) : null }
            onChange={ (event, status) => {setDeliveredStatus(status ? status.id : null);} }
            getOptionLabel={(option) => option.name}
            renderInput={(params) => <TextField {...params} label={t('label.statuses')} placeholder={t('label.statuses')} />}
        />
    );
}

export default ConnectorFormStatusDelivered;